// extracted by mini-css-extract-plugin
export default {"item":"BlueButton_item__K7gxh","pressed":"BlueButton_pressed__wmRup","button":"BlueButton_button__4KTG5"};